import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { FormContainer } from '../../CreateRoutes/CreateForm.styles';
import AuthCheckManager from '../../../Utils/AuthCheck/ManagerCheck.auth';
const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
const HelmetHelper = React.lazy(
  () => import('../../../Components/PageHelmet/HelmetHelper.component')
);
import EditUserDataProvider from '../../../Utils/Users/EditUserDataProvider';
import EditManagerOrEmployeeInner from './EditIMEInner.component';

const EditManagerOrEmployee = () => {
  const { userId } = useParams();

  return (
    <AuthCheckManager>
      <FormContainer>
        <Suspense fallback={<p>Loading page metadata...</p>}>
          <HelmetHelper
            title="Edit Manager or Employee"
            description="Form for editing or creating a manager or user"
          />
        </Suspense>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Company Dashboard"
            oneLink={'/company'}
            two="Edit Manager or Employee"
          />
        </Suspense>
        <EditUserDataProvider userId={userId}>
          {(user) => (
            <>
              <EditManagerOrEmployeeInner user={user} userId={userId} />
            </>
          )}
        </EditUserDataProvider>
      </FormContainer>
    </AuthCheckManager>
  );
};

export default EditManagerOrEmployee;
